var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXyFinance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C24.8366 0 32 7.16342 32 16L31.9979 16.2646C31.8566 24.9791 24.7482 32 16 32L15.8936 31.9997C12.3839 31.9768 9.14297 30.8231 6.51536 28.8858L27.5303 8.14763H21.0988L16.2016 12.8804L14.0343 10.7249H5.44265L11.8625 17.1606L3.25383 25.6711L3.19284 25.5904C1.18834 22.9177 0 19.5978 0 16L0.00214355 15.7354C0.143437 7.02087 7.25184 0 16 0ZM20.667 17.2852L16.3419 21.4822L18.4898 23.6164L27.0916 23.618L20.667 17.2852Z",
    fill: "url(#paint0_radial_11380_3448)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_11380_3448",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.8 2.8) rotate(135) scale(39.0323)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14C5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#0D58EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#100E75"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXyFinance);
export default __webpack_public_path__ + "static/media/xyFinance.662fe16e72c2a11eca1cb962d2d53cb5.svg";
export { ForwardRef as ReactComponent };